import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ProdutoIBPTViewModel, ConsultaProdutoIBPTViewModel, ClassificacoesFiscaisIBPTDetalhesViewModel } from '../../models/atualizacao-ibpt/AtualizacaoIBPTViewModel';

@Injectable()
export class AlmoxarifadosServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Almoxarifado', http);
  }

}
